import FloorPlanGalleryProvider, {
  useFloorPlanGallery,
} from './floor-plan-gallery-provider';

export default FloorPlanGalleryProvider;
export { useFloorPlanGallery };
